// in src/Menu.js
import React, { useEffect } from 'react';
import { BaseIcon } from '@/Utils';
import { SidebarIcons as Icons, Icons as GeneralIcons } from '@/assets';
import MenuItemLink from './MenuItemLink';
import styles from './styles';
import { usePermissions } from 'react-admin';
import ContentMenu from './ContentMenu';
import { SaveData, SaveNotif } from '@/actions';
import IntegrationMenu from './IntegrationMenu';
import MembersMenu from './MembersMenu';
import FeaturesMenu from './FeaturesMenu';
import InventoryMenu from './InventoryMenu';
import SearchMenu from './SearchMenu';
import ExportMenu from './ExportMenu';
import { useSelector } from 'react-redux';
import TerminalMenu from './TerminalMenu';
import AiMenu from './AiMenu';
import ScheduleAdmin from './ScheduleAdmin';
import LogsMenu from './LogsMenu';
import InboxMenu from './InboxMenu';
import { ReactSVG } from 'react-svg';
import useMediaQuery from 'use-mediaquery';
import { usePusher } from '../../../App';
import { removeNoScroll } from '@/actions/Helper';
import { removeSelectedRowsLocalStorageItems } from '@/utils/removeLocalStorage';
import ReportMenu from './ReportMenu';
import IconButtonV2 from '@/ctComponents/IconButton/IconButtonV2';

const showHelpCenter = true;

export default ({ onMenuClick }) => {
  const cls = styles();
  const isMobileDevice = useMediaQuery('(min-width: 763px)');
  const { channels } = usePusher();

  // const AINotif = useSelector(
  //   (state) => state.reducer.notif['whatsapp-messages'] || null
  // );
  const user = useSelector((state) => state?.reducer.user);
  const orderBadge = useSelector((state) => state?.reducer.orderBadge);
  const notif = useSelector((state) => state.reducer.notif || {});

  const [seenCount, setSeenCount] = React.useState(orderBadge.sum);

  const enable_schedule = user?.metas?.enable_schedules?.value;
  const street_turn = user?.metas?.enable_street_turn?.value;
  const mptyTrackingEnable = enable_schedule;
  const enable_street_turn = street_turn;
  const enable_autobooks = user?.metas?.enable_autobooks?.value;
  useEffect(() => {
    if (channels?.privateChannel) {
      const handleNewOrder = (data) => {
        setSeenCount(data?.message?.sum);
      };

      channels.privateChannel.bind('InboxUnreadCount', handleNewOrder);

      return () => {
        channels.privateChannel.unbind('InboxUnreadCount', handleNewOrder);
      };
    }
  }, [channels]);

  useEffect(() => {
    setSeenCount(orderBadge.sum);
  }, [orderBadge]);

  const MenuItem = ({
    to,
    title,
    icon,
    onClick,
    hasBadge = false,
    hasBadgeNum = 0,
  }) => (
    <div style={{ position: 'relative' }}>
      <MenuItemLink
        key={to}
        to={`/${to}`}
        primaryText={title}
        leftIcon={<BaseIcon src={icon} className={cls.icon} />}
        onClick={() => {
          onClick();
          removeNoScroll();
        }}
        sidebarIsOpen
        hasBadge={hasBadge}
      />
      {hasBadge && (
        <div
          style={{
            width: '15px',
            height: '15px',
            background: 'red',
            borderRadius: '50%',
            position: 'absolute',
            right: 33,
            top: 3,
          }}
        />
      )}
      {hasBadgeNum > 0 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '20px',
            height: '20px',
            background: 'red',
            borderRadius: '50%',
            position: 'absolute',
            right: 9,
            top: 3,
            fontSize: 12,
            color: '#fff',
          }}>
          {hasBadgeNum}
        </div>
      )}
    </div>
  );
  const { permissions } = usePermissions();

  const closeMenu = () => {
    SaveData({ openUserMenu: false });
  };

  const handleToggleMenuBar = () => {
    document.getElementById('menuBar').style.display = 'none';
    if (isMobileDevice)
      document.getElementById('menuOpenIcon').style.display = 'flex';
    document.getElementById('layoutMain').style.marginLeft = '2px';
    document.getElementById('app_modal').style.left = '0px';

    // window.updateWidth();
    // window.updateHeadWidth();
    // window.syncScroll('amirbios');
    if (typeof window.updateWidth === 'function') {
      window.updateWidth();
    } else {
      console.warn('window.updateWidth is not defined in this page!');
    }

    if (typeof window.updateHeadWidth === 'function') {
      window.updateHeadWidth();
    } else {
      console.warn('window.updateHeadWidth is not defined in this page!');
    }

    if (typeof window.syncScroll === 'function') {
      window.syncScroll('amirbios');
    } else {
      console.warn('window.syncScroll is not defined in this page!');
    }
  };

  return (
    <div onClick={() => removeSelectedRowsLocalStorageItems()}>
      {permissions === 'admin' && [
        <span className={cls.menuTuggle} key="menuTuggle">
          <IconButtonV2
            text="Menu"
            onClick={() => {
              if (isMobileDevice) {
                handleToggleMenuBar();
              } else {
                closeMenu();
              }
            }}>
            <ReactSVG src={Icons.menuHandler} />{' '}
          </IconButtonV2>
        </span>,
        <MembersMenu
          key="members"
          leftIcon={<BaseIcon src={Icons.MembersNew} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <ContentMenu
          key="content"
          leftIcon={<BaseIcon src={Icons.ContentNew} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <ExportMenu
          key="export"
          leftIcon={<BaseIcon src={Icons.ExportNew} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <ScheduleAdmin
          key="schedule"
          leftIcon={<BaseIcon src={Icons.scheduleIcon} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <MenuItem
          key="chat"
          onClick={() => closeMenu()}
          to="chat"
          title="Chat"
          icon={Icons.ChatNew}
        />,
        <MenuItem
          key="finance"
          onClick={() => closeMenu()}
          to="finance"
          title="Finance"
          icon={Icons.FinanceNew}
        />,
        <IntegrationMenu
          key="integration"
          leftIcon={
            <BaseIcon src={Icons.IntegrationNew} className={cls.icon} />
          }
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <FeaturesMenu
          key="features"
          leftIcon={<BaseIcon src={Icons.FeatureNew} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <AiMenu
          key="ai"
          leftIcon={<BaseIcon src={Icons.AiNew} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,
        <LogsMenu
          key="logs"
          leftIcon={<BaseIcon src={Icons.AlertsNew} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,

        // <MenuItem
        //   onClick={() => closeMenu()}
        //   to="AI"
        //   title="AI"
        //   icon={ChatBarIcons.AI}
        //   // hasBadge={AINotif && !pathname.includes('AI') ? true : false}
        // />,
        // <MenuItem
        //   onClick={() => closeMenu()}
        //   to="logs"
        //   title="Logs"
        //   icon={Icons.Logs}
        // />,
        <MenuItem
          key="docs"
          onClick={() => closeMenu()}
          to="docs"
          title="Docs"
          icon={Icons.DocsNew}
        />,
        showHelpCenter && (
          <MenuItem
            key="help-center"
            onClick={() => closeMenu()}
            to="help-center"
            title="Help Center"
            icon={GeneralIcons.questionMark}
          />
        ),
      ]}
      {permissions === 'user' && [
        <span className={cls.menuTuggle} key="menuTuggle">
          <IconButtonV2
            noBorder
            noHover
            text="Menu"
            onClick={() => handleToggleMenuBar()}>
            <ReactSVG src={Icons.menuHandler} />{' '}
          </IconButtonV2>
        </span>,

        <MenuItem
          key="dashboard"
          onClick={() => closeMenu()}
          to="dashboard"
          title="Dashboard"
          icon={Icons.homeIcon}
        />,

        <SearchMenu
          key="search"
          leftIcon={<BaseIcon src={Icons.searchIcon} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,

        <InboxMenu
          key="inbox"
          leftIcon={<BaseIcon src={Icons.inboxIcon} className={cls.icon} />}
          hasBadgeNum={seenCount}
          onClick={onMenuClick}
          sidebarIsOpen
        />,

        <InventoryMenu
          key="inventory"
          leftIcon={<BaseIcon src={Icons.inventoryIcon} className={cls.icon} />}
          onClick={onMenuClick}
          sidebarIsOpen
        />,

        <MenuItem
          key="appointment"
          onClick={() => closeMenu()}
          to="appointment/"
          title="New Appt"
          icon={Icons.newAppt}
        />,

        <MenuItem
          key="my-appointment"
          onClick={() => closeMenu()}
          to="my-appointment/"
          title="Appointments"
          icon={Icons.apptsList}
        />,

        enable_autobooks === '1' ? (
          <MenuItem
            key="autoBook"
            onClick={() => closeMenu()}
            to="autoBook"
            title="AutoBook"
            icon={Icons.autobook}
          />
        ) : (
          ''
        ),

        mptyTrackingEnable === '1' ? (
          <TerminalMenu
            key="terminal"
            leftIcon={
              <BaseIcon src={Icons.scheduleIcon} className={cls.icon} />
            }
            onClick={onMenuClick}
            sidebarIsOpen
          />
        ) : (
          ''
        ),

        enable_street_turn === '1' ? (
          <MenuItem
            key="inHouse"
            onClick={() => closeMenu()}
            to="inHouse"
            title="In House"
            icon={Icons.inhouse}
          />
        ) : (
          ''
        ),
        <MenuItem
          key="report"
          onClick={() => closeMenu()}
          to="report"
          title="Report"
          icon={Icons.reportIcon}
        />,
      ]}
      {/* <span onClick={() => openSupport()}>support</span> */}
    </div>
  );
};
